import {Link, Outlet, useLocation} from 'react-router-dom';

export default function Services() {
  const location = useLocation();
  const isMainPage = location.pathname === '/services' || location.pathname === '/services/';

  const links = [
    { name: 'Հայտարարագրեր', path: '/services/declarations' },
    { name: 'Սերտիֆիկատներ', path: '/services/certificates' },
  ];

  return (
      <main className="min-h-screen pt-24 pb-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Sidebar */}
            <aside className="lg:w-1/4">
              <div className="bg-white rounded-xl shadow-md p-6 sticky top-24">
                <nav className="flex flex-col space-y-2">
                  <Link
                      to="/product-certification/"
                      className={`px-4 py-2 rounded-lg transition-colors ${isMainPage ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-50'}`}
                  >
                    Ծառայություններ
                  </Link>
                  {links.map((link) => (
                      <Link
                          key={link.path}
                          to={link.path}
                          className={`px-4 py-2 rounded-lg transition-colors ${location.pathname === link.path ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-50'}`}
                      >
                        {link.name}
                      </Link>
                  ))}
                </nav>
              </div>
            </aside>

            {/* Content */}
            <div className="lg:w-3/4 bg-white rounded-xl shadow-md p-8">
              {isMainPage ? (
                  <div className="prose max-w-none text-gray-700">
                    <h1 className="text-xl font-bold text-gray-900 mb-4">Մատուցվող ծառայություններ՝</h1>

                    <p className="mb-2">
                      Մենք իրականացնում ենք արտադրանքի համապատասխանության գնահատում՝ հավատարմագրման ոլորտին համապատասխան.
                    </p>

                    <ul className="list-disc pl-6 space-y-2 mb-6">
                      <li><strong>Հայտարարագրերի գրանցում՝</strong> Եվրասիական Տնտեսական Միության (ԵԱՏՄ/ՄՄ) և Ազգային տեխնիկական կանոնակարգերին համապատասխան:</li>
                      <li><strong>Արտադրանքի սերտիֆիկացում:</strong></li>
                    </ul>

                    <p className='mb-2'>
                      Հայտարարագրման գործընթացը սահմանված է   մեր կազմակերության կողմից մշակված MP-06-2025 «Արտադրանքի համապատասխանության հայտարարագրերի գրանցման» ընթացակարգում: Հայտարարագրերի գրանցման սխեմաները նկարագրված են  «Համապատասխանության գնահատման տիպային սխեմաների մասին» ԵԱՏՀ  2018 թվականի ապրիլի 18-ի N 44 և  «Համապատասխանության գնահատման տիպային սխեմաների մասին» ԵԱՏՀ 2011 թվականի ապրիլի 7-ի N 621 որոշումներում, իսկ հայտարարագրման ընթացակարգերը սահմանված են  ՀՀ Կառավարության 16.01.2014 թվականի N 56-ն «Համապատասխանության գնահատման  ընթացակարգերը սահմանելու մասին» որոշման մեջ:
                    </p>

                    <p className='mb-2'>
                      Սերտիֆիկացման գործընթացը սահմանված է Սերտիֆիկացման կարգ MP-11-2025-ում:
                    </p>

                    <h3 className="text-xl font-bold text-gray-900 mb-4 mt-6">«ԹԵՍԹ ԻՆՎԵՍՏ» ՍՊԸ սերտիֆիկացման մարմինը  իր հայտատուներին առաջարկում է համապատասխանության հայտարարագրերի գրանցում հետևյալ տեխնիկական կանոնակարգերին համապատասխան`</h3>
                    <ul className="list-disc pl-6 space-y-2 mb-6">
                      <li>ՄՄ ՏԿ 005/2011 «Փաթեթվածքի անվտանգության մասին»</li>
                      <li>ՄՄ ՏԿ 009/2011 «Օծանելիքակոսմետիկական արտադրանքի անվտանգության մասին»</li>
                      <li>ՄՄ ՏԿ 015/2011 «Հացահատիկի անվտանգության մասին»</li>
                      <li>ՄՄ ՏԿ 017/2011 «Թեթև արդյունաբերության արտադրանքի անվտանգության մասին»</li>
                      <li>ՄՄ ՏԿ 021/2011 «Սննդամթերքի անվտանգության մասին»</li>
                      <li>ՄՄ ՏԿ 022/2011 «Սննդամթերքի մակնշման մասին»</li>
                      <li>ՄՄ ՏԿ 023/2011 «Մրգերից և բանջարեղենից ստացված հյութամթերքի տեխնիկական կանոնակարգ»</li>
                      <li>ՄՄ ՏԿ 024/2011 «Ճարպայուղային արտադրանքի տեխնիկական կանոնակարգ»</li>
                      <li>ՄՄ ՏԿ 029/2012 «Սննդային հավելումների, բուրավետիչների և տեխնոլոգիական օժանդակ միջոցների անվտանգությանը ներկայացվող պահանջներ»</li>
                      <li>ՄՄ ՏԿ 033/2013 «Կաթի և կաթնամթերքի անվտանգության մասին»</li>
                      <li>ՄՄ ՏԿ 034/2013 «Մսի և մսամթերքի անվտանգության մասին»</li>
                      <li>ԵԱՏՄ ՏԿ 040/2016 «Ձկան և ձկնամթերքի անվտանգության մասին»</li>
                      <li>ԵԱՏՄ ՏԿ 044/2017 «Փաթեթավորված խմելու ջրի, ներառյալ բնական հանքային ջրի անվտանգության մասին»</li>
                      <li>ԵԱՏՄ ՏԿ 051/2021 «Թռչնի մսի և դրա վերամշակումից ստացվող արտադրանքի անվտանգության մասին»</li>
                      <li>ՀՀ կառավարության N 957-Ն առ 16.06.2023թ. որոշում «Կենցաղային և սանիտարահիգիենիկ նշանակության թղթե և քիմիական թելքերից ապրանքներին ներկայացվող պահանջների տեխնիկական կանոնակարգ»</li>
                      <li>ՀՀ կառավարության N 916-Ն առ 08.06.2023թ որոշում «Սինթեթիկ հիմքով լաքերի և ներկերի տեխնիկական կանոնակարգ»</li>
                      <li>ՀՀ կառավարության N 1795-Ն առ 16.12.2004թ. որոշում «Մակերևութաակտիվ միջոցների և մակերևութաակտիվ նյութեր պարունակող լվացող ու մաքրող միջոցների տեխնիկական կանոնակարգ»</li>
                    </ul>

                    <p>
                      «ԹԵՍԹ ԻՆՎԵՍԹ» ՍՊ Ընկերության Սերտիֆիկացման Մարմինը իրականացնում է անկողնային սպիտակեղենի, սեղանի և խոհանոցային սավանների (столовое и кухонное), սրբիչների խմբաքանակի սերտիֆիկացում՝  համաձայն ՄՄ  017/2011 «Թեթև արդյունաբերության արտադրանքի անվտանգության մասին» տեխնիկական կանոնակարգի:
                    </p>

                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 my-6">
                      <p className="text-sm text-blue-800">
                        <strong>Ինչո՞ւ դիմել մեզ:</strong>
                        <ul className="list-disc pl-6 mt-2">
                          <li><strong>Բազմապրոֆիլություն:</strong> Մեկ պատուհանի սկզբունքով սերտիֆիկացում սննդից մինչև տեքստիլ:</li>
                          <li><strong>Իրավական երաշխիք:</strong> Լիակատար համապատասխանություն ԵԱՏՄ և ՀՀ օրենսդրությանը:</li>
                          <li><strong>Փորձագիտական աջակցություն:</strong> Մեր թիմն օգնում է ճիշտ կողմնորոշվել տեխնիկական կանոնակարգերի բարդ պահանջներում:</li>
                        </ul>
                      </p>
                    </div>
                  </div>
              ) : (
                  <Outlet />
              )}
            </div>
          </div>
        </div>
      </main>
  );
}
